import graphql__5759674de902ee705f88 from "./__generated__/DeleteEmailTemplateDialog_emailTemplate.graphql.ts";
import graphql__30358fbe6c1422ff25ea from "./__generated__/DeleteEmailTemplateDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import FormDialog from "./FormDialog";
import {useNavigate} from "react-router-dom";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";
import type {DeleteEmailTemplateDialogMutation} from "./__generated__/DeleteEmailTemplateDialogMutation.graphql";

type Props = {
    queryRef: any,
    handleCloseDialog: () => void
}

const DeleteEmailTemplateDialog: React.FC<Props> = ({queryRef, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const emailTemplate = useFragment(
        graphql__5759674de902ee705f88,
        queryRef
    );

    const handleSubmission = () => {
        commitMutationWithErrorHandling<DeleteEmailTemplateDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__30358fbe6c1422ff25ea,
                variables: {
                    input: {
                        id: emailTemplate.id
                    }
                },
                updater: (store) => {
                    store.delete(emailTemplate.id);
                },
                onCompleted: () => {
                    handleCloseDialog();
                    navigate('/marketing/templates');
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToDeleteEmailTemplate'})
            }
        )
    }

    return (
        <FormDialog
            handleCloseDialog={handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={{}}
            headline={intl.formatMessage({id: 'dialog.DeleteEmailTemplateDialog.headline'})}
            submitLabel={intl.formatMessage({id: 'button.delete'})}
            dangerous={true}
        >
            <p className="text-gray-600">
                {intl.formatMessage({id: 'dialog.DeleteEmailTemplateDialog.confirmMessage'}, {name: emailTemplate.name})}
            </p>
        </FormDialog>
    )
}

export default DeleteEmailTemplateDialog;
